<template>
  <div>
    <div id="banner" style="min-height: 444px;">
      <img :src="indexImg" alt="" v-if="indexImg" class="index-img">
      <img src="https://iiucas.oss-cn-beijing.aliyuncs.com/mainvisial-1.gif" alt="" class="index-img" v-else>
      <div class="container" style="position: absolute;width: 100%;">
        <div class="box-textlayer" style="display: none">
          <p class="txt-mv txt-l">最舒适的私人课堂</p>
          <p class="txt-mv txt-s">Technology for Learning</p>
        </div>
        <div class="form">
          <h4>快速请家教</h4>
          <div class="fg"><input type="text" id="contact" v-model="order.u_name" placeholder="家长姓名" style="cursor: default;">
          </div>
          <!-- <div class="fg"><input type="text" id='stu_xueke' name='stu_xueke' placeholder="家教科目，如初三数学 " maxlength=10></div> -->
          <div class="fg"><input type="text" id="mobile" v-model="order.u_phone" placeholder="手机号码" style="cursor: default;">
          </div>
          <div class="fg" style="">
            <el-select id="node_id1" class="select" v-model="order.u_subject" placeholder="选择年级" @change="getSubjectDetail">
              <el-option v-for="item in subjectList" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
            <el-select style="" id="node_id2" class="select" v-model="order.u_subject_detail" placeholder="选择科目">
              <el-option v-for="item in subjectDetailList" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="fg">
            <input type="text" id="wx_account" v-model="order.u_wechat_number" placeholder="微信号">
          </div>
          <button type="submit" @click="toTutorInfo">提交</button>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div id="nav-link">
      <div class="container">
        <div class="link-box">
          <dl>
            <dt>热门<br>大学</dt>
            <dd>
              <a v-for="(item, index) in univsList" @click="toFacultyList(item, 'univ')">{{item.name}}</a>
            </dd>
          </dl>
          <div class="clear"></div>
        </div>
        <div class="link-box">
          <dl>
            <dt>热搜<br>学科</dt>
            <dd>
              <a v-for="(item, index) in hotSubjectList" @click="toFacultyList(item, 'sub')">{{item.name}}</a>
            </dd>
          </dl>
          <div class="clear"></div>
        </div>
        <div class="link-box">
          <dl class="last">
            <dt>热门<br>区域</dt>
            <dd>
              <a v-for="(item, index) in hotCityArea" @click="toFacultyList(item, 'city')">{{item.name}}</a>
            </dd>
          </dl>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div id="content">
      <div class="container">
        <div class="toptitle">
          <h2>数万名师 总有你所需</h2>
        </div>

        <div class="box box-1">
          <div class="topnav">
            <h3><img src="../assets/icon/images/icon_title1.png" alt="">中小学</h3>
            <ul class="tabnav">
              <li class="active" @click="getNQYTeacher('box-1',0,'icon_math.jpeg', '1, 10, 14')"><a>数学</a></li>
              <li @click="getNQYTeacher('box-1',1,'icon_english.jpeg', '2, 11, 15')"><a>英语</a></li>
              <li @click="getNQYTeacher('box-1',2,'icon_physical.jpeg', '13, 17')"><a>物理</a></li>
              <li @click="getNQYTeacher('box-1',3,'icon_chemistry.jpeg', 18)"><a>化学</a></li>
              <li @click="getNQYTeacher('box-1',4,'icon_china.jpeg', '3, 12, 16')"><a>语文</a></li>
              <div class="clear"></div>
            </ul>
            <a class="more" @click="toFacultyList({id: 1}, 'sub')">查看更多 &gt; &gt;</a>
            <div class="clear"></div>
          </div>
          <div class="tabcont" id="zxx">
            <div class="active tabbox">
              <div class="menu">
                <img src="https://yoouks.oss-cn-shanghai.aliyuncs.com/miucas/icon_math.jpeg" alt="">
              </div>
              <ul>
                <li style="width: 100%;min-height: 280px;position: relative;" v-if="oneList.length<1">
                  <div style="padding: 10px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
                    <span class="iconfont icon-Null-data" style="font-size: 120px;color: #61bfa7;"></span>
                    <p style="text-align: center;margin-top: 10px;">暂无内容</p>
                  </div>
                </li>
                <li v-for="(item, index) in oneList">
                  <router-link :to="{name: 'teacher', params: {teacherID: item.faculty_number}}">
                    <img :src="item.headImg" alt="" v-if="item.headImg" height="110" width="110">
                    <img src="../assets/icon/images/m_default_avatar.jpg" alt="" v-else-if="item.gender==='male'">
                    <img src="../assets/icon/images/w_default_avatar.jpg" alt="" v-else>
                    <i>{{item.name_faculty || '' | peopleSplit}}教员
                      <img v-if="item.certification===1" src="../assets/icon/images/icon_rz.png" alt="">
                      <img v-if="!item.high_star" src="../assets/icon/images/icon_mx.png" alt="">
                    </i>
                    <i>{{item.identity}}</i>
<!--                    <i v-if="item.faculty_identity==='student'">大学生/毕业生</i>-->
<!--                    <i v-else>专职老师</i>-->
                    <p>{{item.evaluation || '' | splitText}}</p>
                  </router-link>
                </li>

              </ul>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="box box-2">
          <div class="topnav">
            <h3><img src="../assets/icon/images/icon_title2.png" alt="">语言</h3>
            <ul class="tabnav">
              <li class="active" @click="getNQYTeacher('box-2',0,'icon_toefl.jpeg', 42)"><a>托福</a>
              </li>
              <li @click="getNQYTeacher('box-2',1,'icon_ielts.jpeg', 43)"><a>雅思</a></li>
              <li @click="getNQYTeacher('box-2',2,'icon_oral.jpeg', 45)"><a>英语口语</a></li>
              <li @click="getNQYTeacher('box-2',3,'icon_japan.jpeg', 50)"><a>日语</a></li>
              <li @click="getNQYTeacher('box-2',4,'icon_korean.jpeg', 51)"><a>韩语</a></li>
              <div class="clear"></div>
            </ul>
            <a class="more" @click="toFacultyList({id: 42}, 'sub')">查看更多 &gt; &gt;</a>
            <div class="clear"></div>
          </div>
          <div class="tabcont" id="language">
            <div class="active tabbox">
              <div class="menu">
                <img src="https://yoouks.oss-cn-shanghai.aliyuncs.com/miucas/icon_ielts.jpeg" alt="">
              </div>
              <ul>
                <li style="width: 100%;min-height: 280px;position: relative;" v-if="twoList.length<1">
                  <div style="padding: 10px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
                    <span class="iconfont icon-Null-data" style="font-size: 120px;color: #d87db7;"></span>
                    <p style="text-align: center;margin-top: 10px;">暂无内容</p>
                  </div>

                </li>
                <li v-for="(item, index) in twoList">
                  <router-link :to="{name: 'teacher', params: {teacherID: item.faculty_number}}">
                    <img :src="item.headImg" alt="" v-if="item.headImg" height="110" width="110">
                    <img src="../assets/icon/images/m_default_avatar.jpg" alt="" v-else-if="item.gender==='male'">
                    <img src="../assets/icon/images/w_default_avatar.jpg" alt="" v-else>
                    <i>{{item.name_faculty || '' | peopleSplit}}教员
                      <img v-if="item.certification===1" src="../assets/icon/images/icon_rz.png" alt="">
                      <img v-if="!item.high_star" src="../assets/icon/images/icon_mx.png" alt="">
                    </i>
                    <i v-if="item.faculty_identity==='student'">大学生/毕业生</i>
                    <i v-else>专职老师</i>
                    <p>{{item.evaluation || '' | splitText}}</p>
                  </router-link>
                </li>

              </ul>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="box box-3">
          <div class="topnav">
            <h3><img src="../assets/icon/images/icon_title3.png" alt="">艺术</h3>
            <ul class="tabnav">
              <li class="active" @click="getNQYTeacher('box-3',0,'icon_piano.jpeg', 60)"><a>钢琴</a></li>
              <li @click="getNQYTeacher('box-3',1,'icon_guitar.jpeg', 75)"><a>吉他</a></li>
              <li @click="getNQYTeacher('box-3',2,'icon_violin.jpeg', 62)"><a>小提琴</a></li>
              <li @click="getNQYTeacher('box-3',3,'icon_watercolor.jpeg', 108)"><a>素描</a></li>
              <li @click="getNQYTeacher('box-3',4,'icon_sketch.jpeg', 105)"><a>水彩画</a></li>
              <div class="clear"></div>
            </ul>
            <a class="more" @click="toFacultyList({id: 60}, 'sub')">查看更多 &gt; &gt;</a>
            <div class="clear"></div>
          </div>
          <div class="tabcont" id="art">
            <div class="active tabbox">
              <div class="menu">
                <img src="https://yoouks.oss-cn-shanghai.aliyuncs.com/miucas/icon_piano.jpeg" alt="">
              </div>
              <ul>
                <li style="width: 100%;min-height: 280px;position: relative;" v-if="threeList.length<1">
                  <div style="padding: 10px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
                    <span class="iconfont icon-Null-data" style="font-size: 120px;color: #58aae4;"></span>
                    <p style="text-align: center;margin-top: 10px;">暂无内容</p>
                  </div>

                </li>
                <li v-for="(item, index) in threeList">
                  <router-link :to="{name: 'teacher', params: {teacherID: item.faculty_number}}">
                    <img :src="item.headImg" alt="" v-if="item.headImg" height="110" width="110">
                    <img src="../assets/icon/images/m_default_avatar.jpg" alt="" v-else-if="item.gender==='male'">
                    <img src="../assets/icon/images/w_default_avatar.jpg" alt="" v-else>
                    <i>{{item.name_faculty || '' | peopleSplit}}教员
                      <img v-if="item.certification===1" src="../assets/icon/images/icon_rz.png" alt="">
                      <img v-if="!item.high_star" src="../assets/icon/images/icon_mx.png" alt="">
                    </i>
                    <i v-if="item.faculty_identity==='student'">大学生/毕业生</i>
                    <i v-else>专职老师</i>
                    <p>{{item.evaluation || '' | splitText}}</p>
                  </router-link>
                </li>
              </ul>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="to-teacher">
          <div class="container enter">
            <img src="../assets/icon/images/enter.png" alt="">
            <router-link :to="{name: 'tutor'}" class="entrance">快速请家教入口</router-link>
          </div>
        </div>
        <div class="new-stu">
          <div class="container">
            <div class="toptitle">
              <h2>最新学员</h2>
            </div>
            <ul>
              <li v-for="(item, index) in studentsList">
                <router-link :to="{name: 'students-detail', params: {detailID: item.id}}" target="_blank"><em>
                  <i v-if="item.u_want_price.indexOf('时')>0">￥{{item.u_want_price}}</i>
                  <i v-else>￥{{item.u_want_price}}元/小时</i>
                  <span>{{item.u_subject_detail.name}}</span>
                </em>
                  <span>{{item.u_city_area.name}}&nbsp; <span v-if="item.u_street">{{item.u_street.name}}</span></span>
                </router-link>
                <p>
                  <span class="user" v-if="item.u_student_sex==='male'">{{item.u_name || ''}} </span>
                  <span class="user" v-else>{{item.u_name || ''}} </span>
                  <span>发布 </span>
                  <span>{{item.add_time | splitTime}}</span></p>
              </li>
              <div class="clear"></div>
            </ul>
          </div>
        </div>
        <div class="help">
          <div class="container">
            <div class="toptitle">
              <h2>预约流程</h2>
            </div>
            <!--            <ul>-->
            <!--              <li>-->
            <!--                <img src="../assets/icon/images/icon_step1.png" alt="">-->
            <!--                <h4>告知需求</h4>-->
            <!--                <p>通过在线客服、或者咨询电话等渠道告知我们您的上课需求</p>-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="../assets/icon/images/icon_step2.png" alt="">-->
            <!--                <h4>匹配老师</h4>-->
            <!--                <p>客服会第一时间与您联系，根据您的需求筛选匹配专业老师</p>-->
            <!--              </li>-->
            <!--              <li class="last">-->
            <!--                <img src="../assets/icon/images/icon_step3.png" alt="">-->
            <!--                <h4>上门授课</h4>-->
            <!--                <p>经您确认后，老师在约定时间上门授课</p>-->
            <!--              </li>-->
            <!--              <div class="clear"></div>-->
            <!--            </ul>-->
            <div class="helpIcon">
              <img src="../assets/icon/images/help.png" alt="" style="width: 100%;">
            </div>
          </div>
        </div>

        <div id="recommend-node-city-container">
          <div class="container">
            <strong>优卡思家教网</strong>隶属于上海汇拼课育科技有限公司，是全国连锁家教机构，专注服务上海中小学学生的专业家教网。本着用心服务的理念、依托先进的互联网技术，
            <strong>优卡思家教网</strong>汇集上海各大名牌大学在校大学生教员和上海各区县中小学在职老师信息，1对1辅导，上门服务， 针对每个学生不同的状况，提供个性化教学方案。
            以最高的效率帮助学生提升成绩。<strong>优卡思家教网</strong>是上海中小学学生家长找家教的第一选择。

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="es6">
  import $ from 'jquery'
  import {
    cityArea,
    facultyList, facultySchoolList,
    subject,
    subjectDetail,
    univList,
    userTutorList,
    userTutorPost
  } from "../config/axioUtil";
  import {mapGetters} from "vuex";
  import {imageCollect, imgPath} from "../config/axioUtilUcas";

  export default {
    name: "index",
    data() {
      return {
        order: {
          id: null,
          u_name: '',
          add_time: "",
          can_show: false,
          faculty: 0,
          is_end: false,
          refresh_time: "",
          status: false,
          u_city_area: null,
          u_duration: "2",
          u_faculty_identity: "",
          u_faculty_require: "",
          u_faculty_sex: "all",
          u_location_detail: "",
          u_phone: null,
          u_student_grade: "",
          u_student_school: "",
          u_student_sex: "",
          u_student_survey: "",
          u_subject: null,
          u_street: null,
          u_subject_detail: null,
          u_want_faculty: null,
          u_wechat_number: "",
          u_weekly: "1",
          u_want_price: "",
          class_hours: "",
        },
        subjectList: [],
        subjectDetailList: [],
        univsList: [],
        hotSubjectList: [],
        hotCityArea: [],
        oneList: [],
        twoList: [],
        threeList: [],
        studentsList: [],
        indexImg: null, // 首页封面
      }
    },
    computed: {
      ...mapGetters({
        currentCity: 'currentCity',
      })
    },
    mounted() {
      this.getImg()
      this.getSubject()
      this.getUnivs()
    },
    methods: {
      getImg(){
        imageCollect({name: '首页'}).then(response=>{
          console.log(response.data.image)
          if (response.data[0].image){
            this.indexImg = response.data[0].image
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      getNQYTeacher(boxIndex, typeIndex, icon, subjectID) {
        $('.' + boxIndex).find('.tabnav').find('li').removeClass('active')
        $('.' + boxIndex).find('.tabnav').find('li').eq(typeIndex).addClass('active')
        $('.' + boxIndex).find('.tabcont').find('.menu').find('img')[0].src = 'https://yoouks.oss-cn-shanghai.aliyuncs.com/miucas/' + icon
        console.log(boxIndex)
        if(boxIndex === 'box-1'){
          facultySchoolList({
            p: 1,
            page_size: 4,
            city: this.currentCity.id,
            professor_subject: subjectID,
          }).then(data=>{
            this.oneList = data.data.results
          }).catch(err=>{
            console.log(err)
          })
        }else {
          facultyList({
            p: 1,
            page_size: 4,
            city: this.currentCity.id,
            professor_subject: subjectID,
          }).then(data=>{
            if (boxIndex === 'box-1'){
              this.oneList = data.data.results
            }else if(boxIndex === 'box-2'){
              this.twoList = data.data.results
            }else if(boxIndex === 'box-3'){
              this.threeList = data.data.results
            }
          }).catch(err=>{
            console.log(err)
          })
        }

      },
      getSubject(){     // 获取科目
        subject().then(data=>{
          this.subjectList = data.data
        }).catch(err=>{
          console.log(err)
        })
      },
      getSubjectDetail(){   // 获取科目详情
        this.order.u_subject_detail = null
        subjectDetail({subject: this.order.u_subject}).then(data=>{
          this.subjectDetailList = data.data
        }).catch(err=>{
          console.log(err)
        })
      },
      toTutorInfo(){      // 前往快速请家教
        let reP = /((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}/;
        if(!this.order.u_name){
          this.$message.warning('姓名不得为空')
          return;
        }else if(!this.order.u_phone){
          this.$message.warning('手机号不得为空')
          return;
        }else if(!reP.test(this.order.u_phone)){
          this.$message.warning('手机号格式错误')
          return;
        }else if(!this.order.u_subject || !this.order.u_subject_detail){
          this.$message.warning('科目不得为空')
          return;
        }else if(!this.order.u_wechat_number){
          this.$message.warning('微信号不得为空')
          return;
        }
        let params = new FormData()
        params.append('order', JSON.stringify(this.order))
        userTutorPost(params).then(response=>{
          if (response.data.status === '0'){
            let tutorID = response.data.data.id
            this.$router.push({name: 'tutorInfo', params: {tutorID: tutorID}})
          }else {
            this.$message.warning(response.data.data.error)
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      getUnivs(){
        univList({'city': this.currentCity.id}).then(data=>{
          this.univsList = data.data.slice(0, 6)
        }).catch(err=>{
          console.log(err)
        })
        subjectDetail().then(data=>{
          this.hotSubjectList = data.data.slice(0, 8)
        }).catch(err=>{
          console.log(err)
        })
        cityArea({'city': this.currentCity.id}).then(data=>{
          this.hotCityArea = data.data.slice(0, 8)
        }).catch(err=>{
          console.log(err)
        })
        facultySchoolList({
          page_size: 4,
          city: this.currentCity.id,
          professor_subject: '1, 10, 14',
        }).then(data=>{
            this.oneList = data.data.results
        }).catch(err=>{
          console.log(err)
        })
        facultyList({
          page_size: 4,
          city: this.currentCity.id,
          professor_subject: 42,
        }).then(data=>{
            this.twoList = data.data.results
        }).catch(err=>{
          console.log(err)
        })
        facultyList({
          page_size: 4,
          city: this.currentCity.id,
          professor_subject: 60,
        }).then(data=>{
            this.threeList = data.data.results
        }).catch(err=>{
          console.log(err)
        })
        userTutorList({
          page_size: 10,
          city: this.currentCity.id,
        }).then(data=>{
          this.studentsList = data.data.results
        }).catch(err=>{
          console.log(err)
        })
      },
      toFacultyList(item, type){
        if (type === 'univ'){
          sessionStorage.setItem('univs', item.id)
          this.$router.push({name: 'faculty-list'})
        }else if(type === 'sub'){
          sessionStorage.setItem('professor_subject', item.id)
          this.$router.push({name: 'faculty-list'})
        }else if(type === 'city'){
          sessionStorage.setItem('professor_area', item.id)
          this.$router.push({name: 'faculty-list'})
        }
      }
    }
  }
</script>

<style scoped>
  @import "../assets/css/modules/index.css";
</style>
<style>
  /* 自定义宽度 */
  .select {
    width: 320px;
    /* selecte 框的高度设置，默认是 40px*/
  }
  .select .el-input__inner{
    height: 35px;
  }
  /* 下面设置右侧按钮居中 */
  .select .el-input__suffix {
    top: 7px;
  }
  .select .el-input__icon {
    line-height: inherit;
  }
  .select .el-input__suffix-inner {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue